import { useSearchParams, useNavigate, useOutletContext } from 'react-router-dom';
import { TermsOfService, PageContainer } from '../../components/signup';
import { AccountSetupFormState, AccountSetupOutletContext } from '../../components/signup/types';

const TermsOfServicePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const { formState, updateFormState } = useOutletContext<AccountSetupOutletContext>();

  const handleNext = () => {
    navigate(`/account-setup/add-provider?token=${token}`);
  };

  const handleFormDataUpdate = (updates: Partial<AccountSetupFormState>) => {
    updateFormState(updates);
  };

  return (
    <PageContainer data-fs-unmask="true">
      <TermsOfService
        onNext={handleNext}
        defaultValues={{
          tos_accepted: formState.terms_accepted?.tos,
          baa_accepted: formState.terms_accepted?.baa,
          aa_accepted: formState.terms_accepted?.aa,
        }}
        onFormDataUpdate={handleFormDataUpdate}
      />
    </PageContainer>
  );
};

export default TermsOfServicePage;
